import {ReadonlyDeep} from 'type-fest';
import {WorkerEntity} from '../../../universal/features/api/entity/dashboard/worker/WorkerEntity';
import {FarmState} from '../../ApiStore';

export default (
  worker: ReadonlyDeep<WorkerEntity>,
  state?: ReadonlyDeep<FarmState>,
  substitution?: number,
) => substitution ?? state?.mining_speed ?? 0;
